import React from 'react'
import { ComingSoon } from '@/components/common/ComingSoon'

const InvoicesPage = () => {
  return (
    <ComingSoon 
      title="AR Invoices"
      description="Manage customer invoices and payments"
    />
  )
}

export default InvoicesPage
